import * as Yup from "yup";

import { TextManager } from "Components/TextContext";
import { ErrorPrefix } from "Constants/constants";
import { BooleanFormType } from "Store/interfaces/FormTypes";
import { AkaHealthProductIntroFormValues } from "./akaHealthProductIntroInterfaces";

export const validationSchema =
  (): Yup.ObjectSchema<AkaHealthProductIntroFormValues> => {
    const { getText } = TextManager;
    return Yup.object()
      .defined()
      .shape({
        isMemberOfNordicSocialSecurity: Yup.mixed<BooleanFormType>()
          .oneOf(
            [BooleanFormType.TRUE],
            `${ErrorPrefix.BREAKING}${getText(
              "healthform.alertdescription.ismemberofnordicsocialsecurity",
            )}`,
          )
          .required(
            getText(
              "healthform.validation.ismemberofnordicsocialsecurity_required",
            ),
          ),
        isCoInsured: Yup.mixed<BooleanFormType>()
          .oneOf(
            [BooleanFormType.FALSE],
            `${ErrorPrefix.BREAKING}${"PLACEHOLDER: RING EN RÅDGIVER"}`,
          )
          .required(getText("healthform.validation.iscoinsured_required")),
      });
  };
